import { useState } from 'react';

interface IUseAutocomplete {
  query: string;
}

interface IAutocompleteItem {
  text: string;
}

interface IUserAutocompleteReturn {
  list: Array<IAutocompleteItem>;
  handleGetAutocomplete: (query: string) => void;
}

export const useAutocomplete = (
  args: IUseAutocomplete
): IUserAutocompleteReturn => {
  const [list, setList] = useState([]);

  const handleGetAutocomplete = async () => {
    const res = await fetch('https://pmapi.reeltime.no/newapi/autocomplete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        q: args.query.toLowerCase()
      })
    });
    const data = await res.json();

    if (data && data[0] && data[0].options && data[0].options.length) {
      setList(data[0].options);
    }
  };

  return { list, handleGetAutocomplete };
};
